import type { ConductorTask } from 'Automations/nodeDefinitions/conductor'

/** The executor a task runs, when it declares one. */
export const taskExecutor = (task: ConductorTask): string | undefined => {
  const configuration = task.inputParameters.taskExecutorConfiguration as
    | { executor?: unknown }
    | undefined

  return typeof configuration?.executor === 'string'
    ? configuration.executor
    : undefined
}
